/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import Box from "@mui/material/Box";

export function technicianDashboarda11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export interface TechnicianDashboardTabPanelProps {
    children: JSX.Element | JSX.Element[];
    value: number;
    index: number;
    noSidePadding: boolean;
    other?: any;
}

const TechnicianDashboardTabPanel = (props: TechnicianDashboardTabPanelProps) => {
    const { children, value, index, noSidePadding, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && noSidePadding !== null && noSidePadding !== undefined && noSidePadding && (
                <Box sx={{ pt: 3, pl: 0, pr: 0, pb: 3 }}>{children}</Box>
            )}
            {value === index && (noSidePadding === null || noSidePadding === undefined || !noSidePadding) && (
                <Box sx={{ p: 3 }}>{children}</Box>
            )}
        </Box>
    );
};

export default TechnicianDashboardTabPanel;
